import React from 'react'
import Subheader from '../../component/Subheader'
import HaldiHead from './HaldiHead'
import HaldiImage from './HaldiImage';
import HaldiBook from './HaldiBook';
import HaldiGallery from './HaldiGallery';
import HaldiCraft from './HaldiCraft';
import HaldiInstagram from './HaldiInstagram';
import HaldiLogoslider from './HaldiLogoslider';
import HaldiService from './HaldiService';

export default function Haldi() {
    const subheadData = {
      image: '../image/haldi-banner.webp',
      heading: 'Handcrafted Beauty for Your Haldi Ceremony',
      pagename: 'Haldi',
    }


    const headdata = {
        title: "Celebrate Haldi Elegance",
        heading: "Vibrant Bridalwear, Thoughtfully Curated",
        description:"Sonam Label designs refined Haldi ensembles that celebrate colour, joy, and tradition through a contemporary lens. Each outfit blends vibrant hues, graceful silhouettes, and delicate handcrafted details rooted in Indian artistry. Created for ease of movement and all-day comfort, our Haldi looks allow the bride to glow naturally while fully enjoying every ritual. With personalised styling and made-to-measure fits, every ensemble feels confident, meaningful, and deeply connected to cultural traditions. Each piece is crafted with intention, creativity, and heartfelt care.",
        buttonText: "Learn More",
        link: "/contact",
    };


    const haldiimage = [
        { src: "../image/haldi-img-1.webp", alt: "Haldi" },
        { src: "../image/haldi-img-2.webp", alt: "Haldi" },
        { src: "../image/haldi-img-3.webp", alt: "Haldi" }
    ];


    const haldiService = {
      tagline: "Haldi Essentials",
      heading: "Celebrate Haldi Traditions with Timeless Style",
      image: "/image/haldi-service.webp",
      accordions: [
        {
          title: "Curated Haldi Looks",
          description:"Receive personalised guidance to select colours, silhouettes, and textures that enhance your natural glow and reflect the joyful spirit of your Haldi celebration."
        },
        {
          title: "Floral Accessory Edit",
          description:"Complete your look with handpicked floral jewellery and accessories that complement your outfit while adding freshness, charm, and festive elegance."
        },
        {
          title: "Bride-Focused Styling",
          description:"Every styling decision is centred around the bride. From outfit balance to accessory pairing, we ensure your look feels effortless, flattering, and uniquely yours."
        },
        {
          title: "Trousseau Mini-Curation",
          description:"Build a cohesive Haldi wardrobe with thoughtfully selected pieces that transition seamlessly from ceremony moments to post-event celebrations."
        },
        {
          title: "Hand-Packed Ritual Gifts",
          description:"Add a thoughtful touch to your Haldi with beautifully curated ritual gifts, carefully packed to reflect warmth, tradition, and celebration."
        },
      ]
    };


    const haldigallery = [
        { src: "../image/haldigallery-1.webp"},
        { src: "../image/haldigallery-2.webp"},
        { src: "../image/haldigallery-3.webp"},
        { src: "../image/haldigallery-4.webp"},
        { src: "../image/haldigallery-5.webp"},
    ];


    const haldiCraft = {
      heading: "Crafting Your Perfect Haldi Moment",
      description:"Your Haldi ceremony deserves an ensemble that reflects joy, colour, and heartfelt tradition. At Sonam Label, we create bespoke Haldi outfits that blend modern design with artisanal craftsmanship, tailored for comfort and confident elegance. From vibrant palettes to intricate accents, every detail is thoughtfully curated to make your Haldi look personal, meaningful, and truly unforgettable, ensuring each moment feels beautifully aligned with your celebration."
    };


    const haldiInsta = [
      {image: "/image/haldiinsta-1.webp"},
      {image: "/image/haldiinsta-2.webp"},
      {image: "/image/haldiinsta-3.webp"},
      {image: "/image/haldiinsta-4.webp"},
      {image: "/image/haldiinsta-5.webp"},
    ];

  return (
    <>
    <Subheader subheadData={subheadData}/>
    <HaldiHead headdata={headdata}/>
    <HaldiImage haldiimage={haldiimage}/>
    <HaldiLogoslider/>
    <HaldiService haldiService={haldiService}/>
    <HaldiBook/>
    <HaldiGallery haldigallery={haldigallery}/>
    <HaldiCraft haldiCraft={haldiCraft}/>
    <HaldiInstagram haldiInsta={haldiInsta}/>
    </>
  )
}
